import { useContext } from "react";
import { AudioContextState } from "providers/AudioProvider/audioProvider";

export const useAudioStateContext = () => {
  return useContext(AudioContextState);
};
